module.exports = __webpack_public_path__ + "img/login.6fdc033b.svg";